// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__oDqWK","quizLink":"style_quizLink__k5OQG","quizImg":"style_quizImg__36UC7","quizTitle":"style_quizTitle___m_lX"};